module.exports = "/_next/static/resources/photo-4-ca2ed0fb77745eacd204cd33e7d3a625.webp";